// The files a source document may be, for a file picker's `accept`. The backend
// decides from the content, not from this list (docs/backend/services/knowledge.md
// → Formats); listing both extensions and types lets every browser filter.
export const ACCEPTED_SOURCE_FILE_TYPES =
  '.pdf,.docx,.odt,.pptx,.png,.jpg,.jpeg,.webp,.tif,.tiff,.avif,' +
  'application/pdf,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation,' +
  'image/png,image/jpeg,image/webp,image/tiff,image/avif';

/** Still being read: until then the document grounds nothing. */
export function isReading(status: string): boolean {
  return status === 'pending' || status === 'processing';
}
